"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const head_1 = __importDefault(require("next/head"));
const react_1 = __importDefault(require("react"));
const useDeviceBasedSrcSet_1 = require("./useDeviceBasedSrcSet");
const PreloadImage = props => {
    const { id, src, resized } = props;
    const { defaultSrc, srcSet } = (0, useDeviceBasedSrcSet_1.useDeviceBasedSrcSet)(resized, src);
    return (react_1.default.createElement(head_1.default, null,
        react_1.default.createElement("link", { key: `p-img-${id}`, rel: "preload", as: "image", href: defaultSrc, 
            // @ts-ignore
            imageSrcSet: srcSet })));
};
exports.default = PreloadImage;
//# sourceMappingURL=PreloadImage.js.map